import React from 'react';
import LayoutHeader from './components/LayoutHeader';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import IntegrationSection from './components/IntegrationSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import LayoutFooter from './components/LayoutFooter';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-800 dark:text-gray-200">
      <LayoutHeader />
      <main>
        <HeroSection /> {/* Soluciones Integrales al Comercio Exterior */}
        <ServicesSection /> {/* Nuestras Soluciones Clave */}
        <IntegrationSection /> {/* Integración Tecnológica Sin Límites */}
        <FaqSection /> {/* Preguntas Frecuentes */}
        <NewsSection /> {/* Novedades y Análisis del Sector */}
        <SuccessStoriesSection /> {/* Casos de Éxito */}
        <ContactSection />
      </main>
      <LayoutFooter />
    </div>
  );
}

export default App;

// DONE